import { render, staticRenderFns } from "./TableRowUnitComponent.vue?vue&type=template&id=70d44bc4&"
import script from "./TableRowUnitComponent.vue?vue&type=script&lang=js&"
export * from "./TableRowUnitComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports